import { useState } from 'react';
import { supabase } from '../supabase';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const { error } = isSignUp
      ? await supabase.auth.signUp({ email, password })
      : await supabase.auth.signInWithPassword({ email, password });

    if (error) setError(error.message);
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0c0c0d', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'DM Sans, sans-serif' }}>
      <div style={{ width: '100%', maxWidth: '400px', padding: '16px' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#4ade80', boxShadow: '0 0 10px #4ade80', margin: '0 auto 12px' }}></div>
          <h1 style={{ fontSize: '20px', fontWeight: '600', color: '#f0efe8', margin: '0 0 4px' }}>ObjectionReady</h1>
          <p style={{ fontSize: '13px', color: '#555550', margin: 0 }}>AI-powered sales call copilot</p>
        </div>

        <div style={{ background: '#141416', border: '0.5px solid rgba(255,255,255,0.08)', borderRadius: '10px', overflow: 'hidden' }}>
          <div style={{ padding: '14px 18px', borderBottom: '0.5px solid rgba(255,255,255,0.08)' }}>
            <p style={{ fontSize: '13px', fontWeight: '500', color: '#f0efe8', margin: 0 }}>{isSignUp ? 'Create your account' : 'Welcome back'}</p>
            <p style={{ fontSize: '11px', color: '#555550', margin: '2px 0 0' }}>{isSignUp ? '3-day free trial, cancel anytime' : 'Sign in to your account'}</p>
          </div>
          <div style={{ padding: '16px 18px' }}>
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '10px' }}>
                <label style={{ fontSize: '11px', color: '#555550', display: 'block', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '.06em' }}>Email</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" required
                  style={{ width: '100%', background: '#1c1c1f', border: '0.5px solid rgba(255,255,255,0.08)', borderRadius: '6px', color: '#f0efe8', fontSize: '13px', padding: '10px 12px', outline: 'none', boxSizing: 'border-box' }} />
              </div>
              <div style={{ marginBottom: '16px' }}>
                <label style={{ fontSize: '11px', color: '#555550', display: 'block', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '.06em' }}>Password</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required
                  style={{ width: '100%', background: '#1c1c1f', border: '0.5px solid rgba(255,255,255,0.08)', borderRadius: '6px', color: '#f0efe8', fontSize: '13px', padding: '10px 12px', outline: 'none', boxSizing: 'border-box' }} />
              </div>
              {error && <p style={{ fontSize: '12px', color: '#f87171', marginBottom: '10px' }}>{error}</p>}
              <button type="submit" disabled={loading}
                style={{ width: '100%', padding: '11px', fontSize: '13px', fontWeight: '500', borderRadius: '6px', cursor: 'pointer', background: 'rgba(74,222,128,0.12)', border: '0.5px solid rgba(74,222,128,0.3)', color: '#4ade80' }}>
                {loading ? 'Loading...' : isSignUp ? 'Start free trial' : 'Sign in'}
              </button>
            </form>
            <p style={{ fontSize: '12px', color: '#555550', textAlign: 'center', marginTop: '12px' }}>
              {isSignUp ? 'Already have an account?' : "Don't have an account?"}
              <button onClick={() => setIsSignUp(!isSignUp)} style={{ background: 'none', border: 'none', color: '#60a5fa', cursor: 'pointer', fontSize: '12px', marginLeft: '4px' }}>
                {isSignUp ? 'Sign in' : 'Sign up'}
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}